<template>
  <v-card
    text
    :class="showDropZone ? 'dashed' : 'mobile-drop-area-width'"
    class="pa-0 mt-3 elevation-0"
  >
    <div id="dropArea" :class="!showDropZone ? 'mobile-drop-area v-btn elevation-2' : ''">
      <input
        v-if="uploadReady"
        id="file"
        ref="file"
        name="file"
        type="file"
        multiple
        @change="onChangeFileUpload()"
      >
      <v-row
        v-if="!uploading"
        align="center"
        justify="center"
        :class="!showDropZone ? '' : 'mt-0'"
      >
        <v-icon
          :size="!showDropZone ? 24 : 32"
          :class="!showDropZone ? 'white--text mb-1' : 'primary--text'"
          class="mr-4"
        >
          cloud_upload
        </v-icon>
        Lisää liitteitä
      </v-row>
      <div v-else>
        Siirretään {{ files.length }} tiedosto{{ files.length > 1 ? 'a' : '' }}...
        <v-progress-linear
          indeterminate
          color="rgb(0,151,167)"
        />
      </div>
    </div>

    <v-alert
      v-if="badAttachment"
      type="warning"
      text
      color="red"
      class="mt-4"
      style="width:100%;"
    >
      Virheellinen tai liian suuri liite!
    </v-alert>

    <v-alert
      v-for="error in errors"
      :key="error"
      type="warning"
      text
      color="red"
      class="mt-4"
      style="width:100%;"
    >
      {{ error }}
    </v-alert>

    <v-alert
      v-if="errors.length"
      type="info"
      class="rounded"
      text
    >
      <p class="mb-2">
        Lisätietoja liitetiedostojen teknisistä rajoituksista
        <a href="https://asiakaspalvelu.dias.fi/hc/fi/articles/360014736579-Kauppakirjan-liitteet">
          DIAS-asiakaspalvelussa
        </a>
      </p>

      <p>
        Otathan yhteyttä
        <b>DIASin asiakaspalveluun</b> jos tarvitset apua liitteiden kanssa:
        Puh. +358 10 201 1190 (puhelun hinta pvm / mpm), sähköposti: asiakaspalvelu@dias.fi
      </p>
    </v-alert>
  </v-card>
</template>
<script>
import axios from 'axios';

export default {
  data: () => ({
    files: [],
    axios,
    uploading: false,
    uploadReady: true,
    badAttachment: false,
    errors: [],
  }),
  computed: {
    showDropZone() {
      // Internet Explorer 6-11
      const isIE = /* @cc_on!@ */false || !!document.documentMode;

      // Edge 20+
      const isEdge = !isIE && !!window.StyleMedia;

      const isMobile = this.$vuetify.breakpoint.smAndDown;

      if (isIE) return false;
      if (isEdge) return false;
      if (isMobile) return false;
      return true;
    },
  },
  methods: {
    onChangeFileUpload() {
      this.uploading = true;
      this.files = this.$refs.file.files;
      this.submitForm();
    },
    clear() {
      this.uploadReady = false;
      this.$nextTick(() => {
        this.uploadReady = true;
      });
    },
    async submitForm() {
      this.errors = [];

      const formData = new FormData();
      for (let i = 0; i < this.files.length; i += 1) {
        formData.append('attachments[]', this.files[i]);
      }

      this.axios.post(process.env.NODE_ENV === 'production'
        ? `/public/backend/api/v1/dias/upload/${this.$route.params.id}`
        : `http://localhost:8888/public/backend/api/v1/dias/upload/${this.$route.params.id}`,
      formData,
      {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then(async (data) => {
        if (data?.data?.result) {
          data.data.result.forEach((error) => {
            if (error?.data?.status === 'INVALID_INPUT') {
              this.errors.push(error.data.description.fin);
            }
          });
        }

        if (!data.data.success) {
          this.badAttachment = true;
        } else {
          this.badAttachment = false;
        }
        this.clear();
        this.uploading = false;
        this.$bus.$emit('GET_DIAS_DOCUMENTS');
      })
        .catch(() => {
          this.uploading = false;
          this.clear();
        });
    },
  },
};
</script>
<style lang="scss">
  #dropArea {
    position: relative;
    width: 100%;
    height: 64px;
    font-size: 14px;
    font-weight: 500;
    text-transform: uppercase;
    text-align: center;
    padding-top: 14px;
    color: rgb(0,151,167);
    border: 1px rgb(0,151,167) solid;
    background-color: transparent;
    transition: background-color 0.5s ease;
    border-radius: 8px !important;
  }
  #dropArea:HOVER {
    background-color: rgba(0,151,167,0.05);
  }

  #dropArea.mobile-drop-area {
    padding-top: 0;
    border: none;
    height: 44px;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;
    background-color:rgb(0, 151, 167);
  }

  .mobile-drop-area-width {
  }

  #file {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
    right: 0;
    left: 0;
    opacity: 0;
  }
  .dashed {
    border-radius: 32px !important;
  }
</style>
